import React from "react";
import presaleIcon from "../../assets/img/presale.jpg";
import swapIcon from "../../assets/img/swap.jpg";
import farmsIcon from "../../assets/img/farm.jpg";
import stakeIcon from "../../assets/img/staking.jpg";
import liquidityIcon from "../../assets/img/liquidity.jpg";
import winIcon from "../../assets/img/win.jpg";
import longTermIcon from "../../assets/img/long-term-value.jpg";
import "./Features.css";
import { TitleBox } from "../Liquidity/Details/styled";

interface Feature {
  title: string;
  description: string;
  icon: string;
}

const Features: React.FC = () => {
  const tradeFeatures: Feature[] = [
    {
      title: "Swap",
      description: "Trade crypto instantly across multiple chains",
      icon: swapIcon,
    },
  ];

  const earnFeatures: Feature[] = [
    {
      title: "Farm",
      description: "Invest in our farms to earn high yields and attractive APRs.",
      icon: farmsIcon,
    },
    {
      title: "Stake",
      description: "Stake your tokens in our staking pools and earn high passive income.",
      icon: stakeIcon,
    },
  ];

  const poolFeatures: Feature[] = [
    {
      title: "Pool",
      description: "Fund liquidity pools, earn trading fees",
      icon: liquidityIcon,
    },
  ];

  const winFeatures: Feature[] = [
    {
      title: "Play",
      description: "Participate in the game and win",
      icon: winIcon,
    },
  ];

  const renderFeatureSection = (title: string, features: Feature[]) => (
    <section className="feature-section">
      <TitleBox>
        <div className="feature-section-title hodl-color glowing-features-header">{title}</div>
      </TitleBox>
      <div className="feature-container">
        {features.map((feature: Feature, index: number) => (
          <div className="feature-box" key={index}>
            <img src={feature.icon} alt={feature.title} className="feature-icon" width="128px" />
            <h3 className="feature-title">{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );

  return (
    <div className="features">
      <TitleBox style={{ marginBottom: "-20px" }}>
        <h1 className="text-center h1">Explore The Ecosystem</h1>
      </TitleBox>
      {renderFeatureSection("Trade", tradeFeatures)}
      {renderFeatureSection("Earn", earnFeatures)}
      {renderFeatureSection("Liquidity", poolFeatures)}
      {renderFeatureSection("Win", winFeatures)}
    </div>
  );
};

export default Features;
